module.exports = __webpack_public_path__ + "img/basket_webshop.df91605.svg";